export interface IMenuClasificacionLieSnp {
  value?: ClasificacionLieSnp;
  text?: string;
}

export class MenuClasificacionLieSnp implements IMenuClasificacionLieSnp {
  constructor(public value?: ClasificacionLieSnp, public text?: string) {}
}

export interface IMenuInstitucionSedeLieSnp {
  value?: InstitucionLieSnp;
  text?: string;
}

export class MenuInstitucionSedeLieSnp implements IMenuInstitucionSedeLieSnp {
  constructor(public value?: IInstitucionDependenciaLieSnp, public text?: string) {}
}

/**
 * Solo para vista, no viaja al back.
 */
export interface IInstitucionDependenciaLieSnp {
  claveInstitucion?: string;
  claveDependencia?: string;
  nombre?: string;
}

export class InstitucionDependenciaLieSnp implements IInstitucionDependenciaLieSnp {
  constructor(public claveInstitucion?: string, public claveDependencia?: string, public nombre?: string) {}
}

export interface IClasificacionLieSnp {
  id?: string;
  nombre?: string;
}

export class ClasificacionLieSnp implements IClasificacionLieSnp {
  constructor(public id?: string, public nombre?: string) {}
}

export interface ITemasLieSnp {
  idTemaPeciti?: number;
  temaPeciti?: string;
}

export class TemasLieSnp implements ITemasLieSnp {
  constructor(public idTemaPeciti?: number, public temaPeciti?: string) {}
}

export interface ISedeLieSnp {
  claveSede?: string;
  claveDependencia?: string;
  nombreDependencia?: string;
  sede?: string;
}

export class SedeLieSnp implements ISedeLieSnp {
  constructor(public claveSede?: string, public claveDependencia?: string, public nombreDependencia?: string, public sede?: string) {}
}

export interface IInstitucionLieSnp {
  claveInstitucion?: string;
  nombreInstitucion?: string;
  sedes?: Array<SedeLieSnp>;
}

export class InstitucionLieSnp implements IInstitucionLieSnp {
  constructor(public claveInstitucion?: string, public nombreInstitucion?: string, public sedes?: Array<SedeLieSnp>) {
    if (!sedes) {
      this.sedes = [];
    }
  }
}

export interface ILieSnp {
  cveLinea?: string;
  nombreDeLinea?: string;
  clasificacion?: ClasificacionLieSnp;
  fechaAlta?: Date;
  temasPrioritariosPeciti?: Array<TemasLieSnp>;
  instituciones?: Array<InstitucionLieSnp>;
  justificacion?: string;
  activo?: boolean;
}

export class LieSnp implements ILieSnp {
  constructor(
    public cveLinea?: string,
    public nombreDeLinea?: string,
    public clasificacion?: ClasificacionLieSnp,
    public fechaAlta?: Date,
    public temasPrioritariosPeciti?: Array<TemasLieSnp>,
    public instituciones?: Array<InstitucionLieSnp>,
    public justificacion?: string,
    public activo?: boolean
  ) {
    if (!clasificacion) {
      this.clasificacion = null;
    }
    if (!instituciones) {
      this.instituciones = [];
    }
    this.activo = true;
  }
}

export interface ILieFormSnp {
  cveLinea?: string;
  nombreDeLinea?: string;
  clasificacion?: ClasificacionLieSnp;
  fechaAlta?: Date;
  temasPrioritariosPeciti?: Array<TemasLieSnp>;
  instituciones?: Array<IInstitucionDependenciaLieSnp>;
  justificacion?: string;
  activo?: boolean;
}

export class LieFormSnp implements ILieFormSnp {
  constructor(
    public cveLinea?: string,
    public nombreDeLinea?: string,
    public clasificacion?: ClasificacionLieSnp,
    public fechaAlta?: Date,
    public temasPrioritariosPeciti?: Array<TemasLieSnp>,
    public instituciones?: Array<IInstitucionDependenciaLieSnp>,
    public justificacion?: string,
    public activo?: boolean
  ) {
    if (!clasificacion) {
      this.clasificacion = null;
    }
    if (!instituciones) {
      this.instituciones = [];
    }
    if (!activo) {
      this.activo = true;
    }
  }
}
